import React from 'react'
import { Link } from 'react-router-dom'
import devavatar from '../../assets/img/avatar.webp'
import './result.css'

export default function ResultSearch({ searchResult }) {
  const search = searchResult;

  return (
    <div className="devs-search row">
      {search.map((item) => (
        <div className='col-md-6 col-xl-4' key={item.key}>

          <Link to={`/user/${item.uid}`}>

            <div className='dev d-flex align-items-center'>                                                <div>
              <img src={devavatar} alt='dev-avatar' />
            </div>

              <div className='d-block dev-info'>
                <p className='secondary_clr weight-bold'>{item.name}</p>
                {item.nickname ? (
                  <p>Vulgo<b> {item.nickname}</b></p>
                ) : (<></>)}
                <p>Tecnologia Favorita: <b>JavaScript</b></p>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  )
}
